import axios from 'axios';
import { convertKeysToCamelCase } from '../utils';

// const baseUrl = 'http://' + window.location.hostname + ":5002";
const baseUrl = 'https://tl-api.titancapital.au'

async function getSuggestedAddress(token, q) {
    const res = await axios.get(`${baseUrl}/suggest?q=${q}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        withCredentials: true // equivalent to credentials: 'include'
    });
    //console.log(res);
    return res?.data?.results;
}

async function getParsedAddress(token, q) {
    const res = await axios.get(`${baseUrl}/parse?q=${q}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        withCredentials: true // equivalent to credentials: 'include'
    });
    //console.log(res);
    return res?.data?.results;
}

async function getReport(token, queryObj) {
    const queryString = new URLSearchParams(convertKeysToCamelCase(queryObj)).toString();
    const res = await axios.get(`${baseUrl}/query?${queryString}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        withCredentials: true // equivalent to credentials: 'include'
    });
    //const res = await axios.get(`${baseUrl}/test?${query}`);

    //console.log(res);
    return res?.data;
}

async function getSwimmingPoolInfo(token, queryObj) {
    const queryString = new URLSearchParams(convertKeysToCamelCase(queryObj)).toString();
    const res = await axios.get(`${baseUrl}/pool?${queryString}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        withCredentials: true // equivalent to credentials: 'include'
    });
    //const res = await axios.get(`${baseUrl}/test?${query}`);

    //console.log(res);
    return res?.data;
}

async function dropboxSharing(token, q) {
    const res = await axios.get(`${baseUrl}/sharing?q=${q}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        withCredentials: true // equivalent to credentials: 'include'
    });
    //console.log(res);
    return res?.data?.message;
}

async function getPricing(token, securities, application) {
    let body = convertKeysToCamelCase({
        securities: securities,
        loan_term: application?.loan_term,
        guarantor_count: application?.guarantor_count,
        priority: application?.priority || 'Standard Processing',
        borrower_structure: application?.borrower_structure || 'No Trust Involved',
        da_status: application?.da_status || '--'
    })

    const res = await axios.post(`${baseUrl}/pricing`, body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        withCredentials: true // equivalent to credentials: 'include'
    });
    return res?.data;
}


async function getProfile(token) {

    const res = await axios.get(`${baseUrl}/api/user/profile`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        withCredentials: true // equivalent to credentials: 'include'
    });
    return res.data;
}


async function getRedirect(token, url) {
    const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
    });

    const data = await response.json();
    if (data?.redirect_url) window.open(data.redirect_url, '_blank');
}

export {
    getSuggestedAddress,
    getParsedAddress,
    getReport,
    getSwimmingPoolInfo,
    dropboxSharing,
    getPricing,
    getProfile,
    getRedirect,
};